import { render, staticRenderFns } from "./tTariffs.vue?vue&type=template&id=b3c5baa8"
import script from "./tTariffs.vue?vue&type=script&lang=js"
export * from "./tTariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports